var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 14.0001C11.4484 14.0001 11.0007 13.5523 11.0007 13.0001V10.0001C11.0007 9.44778 11.4484 9.00006 12.0007 9.00006C12.5529 9.00006 13.0007 9.44778 13.0007 10.0001V13.0001C13.0007 13.5523 12.5529 14.0001 12.0007 14.0001Z",
    fill: "#CD2626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5007 16.5001C10.5007 15.6716 11.1722 15.0001 12.0007 15.0001C12.8291 15.0001 13.5007 15.6716 13.5007 16.5001C13.5007 17.3285 12.8291 18.0001 12.0007 18.0001C11.1722 18.0001 10.5007 17.3285 10.5007 16.5001Z",
    fill: "#CD2626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2308 3.21566C10.9806 1.79099 13.0207 1.79098 13.7705 3.21566L22.1141 19.0686C22.8151 20.4004 21.8493 22.0001 20.3443 22.0001L3.65702 22.0001C2.152 22.0001 1.18623 20.4004 1.88719 19.0686L10.2308 3.21566ZM20.3443 20.0001L12.0007 4.14716L3.65702 20.0001L20.3443 20.0001Z",
    fill: "#CD2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d8e48502f58519580e1d95620fd92e13.svg";
export { ForwardRef as ReactComponent };